<template>
  <div class="custom-height-payments">
    <export-modal ref="export_wallet" :records="export_statement === true ?  exportData : []" />
    <div class="d-none d-md-block">
      <ag-grid :records="records" v-on:refresh="refresh" />
    </div>
    <div class="d-block d-md-none">
      <ag-grid-mobile :records="records" v-on:refresh="refresh" />
    </div>
    <b-form-group class="col-xl-12 btn-bottom px-md-0">
      <b-row>
        <b-col lg="6" offset-lg="6" cols="12">
          <b-button variant="custom"  @click="extract(true)" pill block class="mt-3">Export</b-button>
        </b-col>
      </b-row>
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import ExportModal from './Export'
import AgGrid from './Ag-Grid'
import AgGridMobile from './Ag-Grid-Mobile'

export default {
  components: {
    ExportModal,
    AgGrid,
    AgGridMobile
  },
  props: {
    records: Array
  },
  data () {
    return {
      perPage: 10,
      currentPage: 1,
      type: null,
      export_statement: false,
      exportData: [],
      tableFields: [
        { key: 'payment_type', sortable: true, label: 'Type' },
        { key: 'session.date_stamp', sortable: true, label: 'Date', class: 'text-right' },
        { key: '_id', label: 'Sender / Recipient' },
        { key: 'reference', sortable: true, label: 'Reference' },
        { key: 'ledger', sortable: true, label: 'Ledger' },
        { key: 'payment_method', sortable: true, label: 'Method' },
        { key: 'amount', sortable: true, label: 'Amount', class: 'text-right' }
      ]
    }
  },
  computed: {
    ...mapGetters('currency', {
      currencyObject: 'fullObject'
    }),
    ...mapState({
      userStore: state => state.user
    }),
    rows () {
      return this.records.length
    }
  },
  methods: {
    currency: function (currency) {
      return this.currencyObject(currency || 'ZAR')
    },
    extract: function (status) {
      this.export_statement = status
      this.$bvModal.show('export_wallet')
    },
    refresh: function () {
      this.$emit('refresh', true)
    }
  },
  watch: {
    records (val) {
      this.export_statement = false
      if (!val) return
      this.exportData = []
      this.exportData = val
    }
  }
}
</script>

<style scoped>
.customPagination>li>a {
  color: #0a083e;
}

.customPagination>li.active>a,
.customPagination>li>a:hover {
  color: white;
  background-color: #0a083e !important;
}
</style>
